import Axios from "../_helpers/axiosHelper.ts";

export const getFilesUrls = (paths: string[]): Promise<{ urls: string[] }> => {
  return Axios.post(`/files/url`, { paths });
};
